/** @jsxImportSource @emotion/react */

import { useLazyQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { FC, useEffect, useState } from 'react'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import {
  findAllRecommendedArticleGroup,
  findAllRecommendedArticleGroupVariables,
  findAllRecommendedArticleGroup_findAllRecommendedArticleGroup_items as IGroup,
} from '__generatedTypes__/findAllRecommendedArticleGroup'
import { ClassroomTabEnum } from '__generatedTypes__/globalTypes'
import { FIND_ALL_RECOMMENDED_ARTICLE_GROUP } from 'queries/recommendedArticleGroup'
import { usePlatformsAndSubjects, Props as UsePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { SubjectTabs } from 'components/SubjectsTabs'
import RecommendedArticlesContent from './RecommendedArticlesContent'
import * as classes from './styles'

const platformsAndSubjectsProps: UsePlatformsAndSubjects = {
  filterSubjects: (subject) =>
    !!subject.classroomTab.find(({ tabEnum }) => tabEnum === ClassroomTabEnum.RecommendedArticles),
}

const RecommendedArticles: FC = () => {
  const { subjects, selectedSubject, selectSubject } = usePlatformsAndSubjects(platformsAndSubjectsProps)
  const [groups, setGroups] = useState<IGroup[]>([])

  const [getGroups, { data: groupsData }] = useLazyQuery<
    findAllRecommendedArticleGroup,
    findAllRecommendedArticleGroupVariables
  >(FIND_ALL_RECOMMENDED_ARTICLE_GROUP)

  useEffect(() => {
    selectedSubject &&
      getGroups({
        variables: {
          query: {
            take: TAKE_ALL_ITEMS_COUNT,
            where: {
              subject: {
                id: selectedSubject.id,
              },
            },
          },
        },
      })
  }, [selectedSubject])

  useEffect(() => {
    groupsData && setGroups(groupsData?.findAllRecommendedArticleGroup.items || [])
  }, [groupsData])

  if (!selectedSubject) {
    return null
  }

  return (
    <div css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Recommended Articles
      </Typography>
      <SubjectTabs subjects={subjects} selectedSubject={selectedSubject} selectSubject={selectSubject} />
      <RecommendedArticlesContent groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    </div>
  )
}

export default RecommendedArticles
